import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import AnswerDropDown from "../component/AnswerDropDown";
import useForm from "../../../../hooks/useForm";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import URLS from "../../../../API/Axios/URLS";


function Selectables({
                         data,
                         showAnswer,
                         selectedOptions,
                         setSelectedOptions
                     }) {


    return (
        <div className={"grid grid-cols-3 md:grid-cols-8 gap-4"}>

            {
                data?.wordList?.map((option, index) => {
                    return (
                        <div
                            onClick={() => {
                                if (!showAnswer) {
                                    if (selectedOptions?.includes(option)) {
                                        setSelectedOptions(selectedOptions.filter((item) => item !== option))
                                    } else {
                                        setSelectedOptions([...selectedOptions, option])
                                    }
                                }


                            }}
                            className={`border border-gray-500 p-2 px-3 text-center
                            ${showAnswer && data?.correct?.includes(option) && selectedOptions?.includes(option) ? "bg-green-500 text-white border-green-200" : ""}
                            ${showAnswer && data?.correct?.includes(option) && !selectedOptions?.includes(option) ? "font-semibold text-green-500 border-2 border-green-600" : ""}
                            ${selectedOptions?.includes(option) ? "bg-blue-500 border-blue-200 text-white" : ""}
                            ${showAnswer && !data?.correct?.includes(option) && selectedOptions?.includes(option) ? "bg-red-500 text-white border-red-200" : ""}
                            `}>
                            <p>{option}</p>

                        </div>
                    )
                })}
        </div>
    )
}

export default function ReadAndSelectNew({className, ...props}) {
    const {id} = useParams()
     const {question, questionActions} = useQuestion()
     const [Yes, setYes] = useState(null)
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: [],
    })
    const [isSubmitted, setIsSubmitted] = useState(false)

    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [id]);


    function submitAnswer() {
        if (Yes === null) {
            actions.setError({
                non_field_errors: ["Please select at least one option Yes or No"]
            })
            return
        }
        setIsSubmitted(true)
        actions.post(URLS.genericQuestionView,(data)=>{
            return {
                ...data,
                answer:"noting"
            }
        }).then(response => {

        })

    }

    function getBgColor(option) {
        if (option && isSubmitted === false)
            return {
                backgroundColor: "rgb(254 152 3 / var(--tw-bg-opacity))",
                color: "white"
            }
    }

    function getSubmitColor(isSelected, isCorrect) {
        if(!isSubmitted){
            return {
            }
        }
        if ( isCorrect) {
            return {
                backgroundColor: "green",
                color: "white"
            }
        }
        if (isSelected && !isCorrect) {
            return {
                backgroundColor: "red",
                color: "white"
            }
        }

    }

    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit + 2000}

            />
            {/*<GenericQuestionModal*/}
            {/*    result={response}*/}
            {/*    showModal={showModal} setShowModal={setShowModal}/>*/}
            <div className={" flex flex-col p-2 py-8 justify-between border-b-2"}>

                <div className={"flex flex-col justify-center items-center gap-8"}>
                    <p className={"text-3xl font-bold capitalize text-center"}>
                        {question?.word}
                    </p>

                    <div className={"inline-flex gap-4"}>
                        <div
                            style={{
                               ...getBgColor(Yes),
                                ...getSubmitColor(Yes, question?.isValid)
                            }}
                            onClick={() => {
                                if (isSubmitted === false) {
                                    setYes(true)
                                }
                            }}
                            className={"rounded-md cursor-pointer border-[1px] w-[100px] font-semibold text-center py-2"}>
                            Yes
                        </div>
                        <div
                            style={{
                                ...getBgColor(Yes === null ? null : !Yes),
                                ...getSubmitColor(  !Yes, !question?.isValid)
                            }}
                            onClick={() => {
                                if (isSubmitted === false) {
                                    setYes(false)
                                }
                            }}
                            className={"rounded-md border-[1px] cursor-pointer w-[100px] font-semibold text-center py-2"}>
                            No
                        </div>
                    </div>

                </div>

                <FormNoneFieldErrors className={"mt-3"}
                                     errors={error?.answer || error?.non_field_errors || error?.time}/>

            </div>
            <QuestionFooter className={"mx-4 my-2"}
                            loading={loading}
                            disabled={isSubmitted}
                            onClickSubmit={submitAnswer}


            />

            <AnswerDropDown
                headerTitle={"Answer"}
                justifications={
                    question?.correct?.join(", ")
                }
            />


        </div>

    )
}
